<template>
    <div>
        <viframe v-if="iframeBoolean" @closeIfream="closeIfream" :itemData="itemData"></viframe>
        <div v-if="!iframeBoolean" class="background">

            <el-container class="contentBox imgContent">
                <el-main>
                    <div class="contentBox-left">
                        <div class="charater">
                            <img src="../../../../static/img/nanjuese.png" alt="">
                        </div>
                    </div>
                    <div class="contentBox-right">
                        <!--<div id="headPage">-->
                        <!--<el-header style="height: inherit !important;position: relative">-->
                        <!--<div class="main-header-box">-->
                        <!--<div class="main-header-right-box">-->
                        <!--<img src="../../../../static/img/touxiangkaobei5.png" alt="">-->
                        <!--<img src="" alt="">-->
                        <!--</div>-->
                        <!--<div class="main-header-left-box">-->
                        <!--<div>{{userData.nikiName}}</div>-->
                        <!--<div class="names" style="margin-top: 15px;">角色：{{userData.roleList[0].roleName}}</div>-->
                        <!--<div class="names" v-if="userData.experience != null">经验：{{userData.experience}}</div>-->
                        <!--<div class="names" v-else>经验：0</div>-->
                        <!--</div>-->
                        <!--</div>-->
                        <!--</el-header>-->
                        <!--</div>-->
                        <div class="cont">
                            <div class="contentBox-right-box" v-for="( item , index ) in data.row"
                                 @click="handleItem(item,index)">
                                <div class="grid-content bg-purple">
                                    <div>任务名称：{{item.name}}</div>
                                    <div style="padding: 10px 0 ; box-sizing: border-box">
                                        任务内容：{{item.content}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-main>
            </el-container>
        </div>
    </div>
</template>

<script>
    import viframe from '../../../components/iframe/index'

    export default {
        components: {
            viframe
        },
        data() {
            return {
                userData: '',
                iframeBoolean: false, //布尔值
                data: [1, 2, 3, 4, 5, 6, 7, 8],
                itemData: {},//单个任务信息
                weather: {},
            }
        },
        methods: {
            //获取个人信息
            // getData() {
            //    this.$axios.get(this.URL.info).then(res => {
            //        console.log(res);
            //        if (res.status === 200) {
            //         sessionStorage.setItem('userData', JSON.stringify(res.data))
            //         this.userData = res.data
            //         this.$emit('change_header',false)
            //        }
            //    })
            // },
            //
            closeIfream(data) {
                this.iframeBoolean = data
            },

            //获取练习模式列表 数据
            getData() {
                let params = {
                    name: '',
                    isOpen: '',
                    page: '',
                    size: '',
                    content: '',
                    url: '',
                }
                this.$axios.get(this.URL.uExercise.showUExerciseList, {params}).then(res => {
                    if (res.status === 200) {
                        this.data = res.data
                    } else {

                    }
                })
                    .catch({})
            },

            //天气
            getuModel() {
                let params = {
                    type: 8
                }
                this.$axios.get(this.URL.uModel.selectUModelList, {params}).then(res => {
                    if (res.status === 200) {
                        this.weather = res.data
                    }
                })
                    .catch({})
            },

            //判断点击item的type
            handleItem(item, index) {
                if (item.type == 0) {
                    //普通的ifream

                    // this.itemData = item
                    // this.iframeBoolean = true

                    window.open('#/webglTest?model3D=' + item.url.substring(item.url.indexOf('id')*1 +3, item.url.indexOf('&')));
                } else if (item.type == 1) {
                    //天气
                    console.log(this.weather);
                    this.itemData = this.weather
                    this.iframeBoolean = true


                } else if (item.type == 2) {
                    //tiure
                    sessionStorage.setItem('flag', '0')
                    this.goMain('/tizure');
                } else {
                    //psPlugin
                    sessionStorage.setItem('flag', '0')
                    this.goMain('/psPlugin')
                }
            },
        },
        created() {
            this.getuModel()
            this.getData()
            //获取个人信息
            // this.userData = JSON.parse(sessionStorage.userData);
        },
        watch: {
            header(val) {
                console.log(val);
                this.getData()
            }
        }
    }
</script>

<style lang="less" scoped>

    .background {
        width: 100%;
        height: 100vh;
        background: url("../../../../static/img/timg1.jpeg") no-repeat;
        background-size: cover;

    }

    .contentBox {
        .el-main {
            display: flex;
            padding: 0px;

            .contentBox-left {
                width: 30%;
                position: relative;

                .charater {
                    width: 100%;
                    position: absolute;
                    bottom: 4vh;

                    img {
                        width: 53%;
                    }
                }
            }

            .contentBox-right {
                width: 70%;

                #headPage {
                    height: 13vh;

                    .el-header {
                        .main-header-box {
                            position: absolute;
                            right: 14.9%;
                        }
                    }

                    .main-header-box {
                        display: flex;
                        position: absolute;
                        right: 11%;

                        .main-header-left-box {
                            margin-left: -240px;
                            margin-top: 15px;
                            font-size: 12px;

                            .names {
                                font-size: 14px;
                                color: #fff;
                            }

                            :first-child {
                                font-size: 20px;
                                color: #ffffff;
                                height: 30px;
                                font-weight: bold;
                            }
                        }

                        img {
                            width: 100%;
                        }
                    }
                }

                .cont {
                    display: flex;
                    flex-wrap: wrap;
                    margin-top: 4vh;

                    .contentBox-right-box {
                        width: 45%;
                        margin-left: 10px;
                        margin-bottom: 2vh;
                    }
                }

            }
        }

        .el-header {
            height: 15px !important;
        }
    }

    .el-col {
        margin-top: 20px;
        border-radius: 4px;
    }

    .bg-purple {
        background-color: #000000;
        background-color: rgba(5, 4, 8, 0.2);

        div {
            font-size: 16px;
            color: #FFFFFF;
        }
    }

    .grid-content {
        box-sizing: border-box;
        padding: 20px 20px;
        border-radius: 4px;
        min-height: 220px;
    }
</style>



// WEBPACK FOOTER //
// src/views/main/taskModel/main-taskModel.vue